import axios from "axios";
import { FormEvent } from "react";
import { toast } from "react-toastify";
import { SetState } from "zustand";
import { IVeiculoPlacaStore } from "..";

import { IVeiculo } from "../../../interface/detran";

export interface IVeiculoPlacaModuleStore {
  resultadoVeiculoPlaca: IVeiculo | null;
  mensagemVeiculo?: string;
  consultaVeiculoPlaca(
    url: string,
    getPlaca: string,
    e?: FormEvent
  ): Promise<void>;
  limparConsultaVeiculoPlaca(): void;
}

export default (set: SetState<IVeiculoPlacaStore>) =>
  ({
    resultadoVeiculoPlaca: null,
    async consultaVeiculoPlaca(url, getPlaca, e) {
      e?.preventDefault();
      try {
        const storedToken = sessionStorage.getItem("@webSDS:token");

        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: true,
          },
        }));

        const response = await axios.get(`${url}/buscarPlaca/${getPlaca}`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        });

        if (response.status === 200) {
          set((state) => ({
            ...state,
            global: {
              ...state.global,
              loading: false,
            },
            veiculo: {
              ...state.veiculo,
              resultadoVeiculoPlaca: response.data,
            },
          }));
        }
        if (response.status === 400) {
          toast.error(`${response.data.message}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        }
        if (response.status === 401) {
          toast.error(
            "A SUA SESSÃO EXPIROU, EFETUE LOGIN NOVAMENTE PARA CONTINUAR USANDO O POLÍCIA ÁGIL.",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            }
          );
          // logout()
        }
        if (response.status === 404) {
          set((state) => ({
            veiculo: {
              ...state.veiculo,
              resultadoVeiculoPlaca: null,
              mensagemVeiculo: response.data,
            },
          }));
        }
        if (response.status === 500 || response.status === 503) {
          toast.error("ERRO NO SERVIDOR, TENTE MAIS TARDE!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
          return;
        }
        if (response.status === 504) {
          toast.error(
            "O SERVIDOR DEMOROU MUITO PARA RESPONDER, TENTE NOVAMENTE EM INSTANTES.",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            }
          );
          return;
        }
      } catch (error) {
        toast.error("ERRO DE CONEXÃO! VERIFIQUE SUA INTERNET!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      } finally {
        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: false,
          },
        }));
      }
    },
    limparConsultaVeiculoPlaca() {
      set((state) => ({
        ...state,
        veiculo: {
          ...state.veiculo,
          resultadoVeiculoPlaca: null,
          mensagemVeiculo: undefined,
        },
      }));
    },
  } as IVeiculoPlacaModuleStore);
